import type { AppSpecificConfiguration } from 'owa-msaljs';
import { getOrigin } from 'owa-url/lib/getOrigin';

const msalConfiguration: AppSpecificConfiguration = {
    auth: {
        clientId: '472dd75b-cdf2-42a0-9fec-b86cefca8135',
        /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
         *	> Function getOrigin called at module scope is not allowed. This may cause unwanted side effects. */
        redirectUri: `${getOrigin()}/places/`,
    },
    disableGetAuthTokenFallback: true,
};

export default msalConfiguration;
